(function() {
  'use strict';

  angular
    .module('odRecords', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ngRoute', 'ngMaterial', 'toastr']);

})();



(function() {
  'use strict';

  angular
      .module('odRecords')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Angular Material Design',
        'url': 'https://material.angularjs.org/#/',
        'description': 'The Angular reference implementation of the Google\'s Material Design specification.',
        'logo': 'angular-material.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('odRecords')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('odRecords')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('odRecords')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('odRecords')
    .controller('MainController', MainController)
    .controller('NavController',NavController);


  /** @ngInject */
  function MainController($log,$timeout,$mdSidenav,$window,$mdDialog) {
    var vm = this;

    angular.element($window).bind("scroll", function() {
      $mdSidenav('left').close();
    });

    vm.searchStr=null;
    vm.bands=[
      { name: 'All Bands', count:214},
      { name: 'Sound Ordnance', count:62} ,
      { name: 'Rescue Team', count: 48},
      { name: 'Dale Dale', count: 2},
      { name: '2-Cane', count:3},
      { name: 'Provert', count:7} ];

    vm.odSongs=[
      { name: 'Newtron', artist:'Sound Ordnance', isDownload:true, isBuy:true, album:"Overdope" },
      { name: 'Overdope', artist:'Sound Ordnance', isDownload:true, isBuy:true, album:"Overdope" },
      { name: 'Influx', artist:'Sound Ordnance', isDownload:true, isBuy:true, album:"Overdope" },
      { name: 'Your Soul', artist:'Sound Ordnance', isDownload:true, isBuy:true, album:"Overdope" },
      { name: 'Mode Flip', artist:'Sound Ordnance', isDownload:true, isBuy:true, album:"Overdope" },
      { name: 'Light Jump', artist:'Sound Ordnance', isDownload:true, isBuy:true, album:"Overdope" },
      { name: 'Four', artist:'Sound Ordnance', isDownload:true, isBuy:true, album:"Overdope" },
      { name: 'Continuum', artist:'Sound Ordnance', isDownload:true, isBuy:true, album:"Overdope" },
      { name: 'Stand By', artist:'Sound Ordnance', isDownload:true, isBuy:true, album:"Overdope" },
      { name: 'The Gift', artist:'Sound Ordnance', isDownload:true, isBuy:true, album:"Overdope" },
      { name: 'Space Walk', artist:'Sound Ordnance', isDownload:true, isBuy:true, album:"Overdope" },
      { name: 'Prisms', artist:'Sound Ordnance', isDownload:true, isBuy:true, album:"Overdope" },
      { name: 'Crimson Night', artist:'Sound Ordnance', isDownload:true, isBuy:true, album:"Overdope" }



    ];

    vm.shareMenuItems=[
      { "name":"Facebook","icon":"zmdi-facebook" },
      { "name":"iTunes", "icon":"zmdi-apple" },
      { "name":"youTube", "icon":"zmdi-youtube"},
      { "name":"SoundCloud", "icon":"zmdi-soundcloud" }
      ];



    vm.odPlayerOptions= {
      "state":"ready"

    };

    vm.downloadSong=function(item)
    {
      $log.log("<downloadSong> "+angular.toJson(item) );
    };

    vm.classAnimation = '';

    vm.emailClick=function (ev) {

      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('body')))
          .clickOutsideToClose(true)
          .title('Email')
          .textContent('oolotronic@hotmail.com')
          .ariaLabel('emailAdr')
          .ok('OK')
          .targetEvent(ev)
      );

    };




    vm.openLeftMenu = function() {
      $mdSidenav('left').toggle();
    };

  };

  function NavController ($scope, $timeout, $mdSidenav, $log) {
    $log.log("<NavController>");
    // $scope.close = function () {
    //   $mdSidenav('left').close()
    //     .then(function () {
    //       $log.debug("close LEFT is done");
    //     });
    // };

    $scope.openLeftMenu = function() {
      $mdSidenav('left').toggle();
    };

  };

})();

(function() {
  'use strict';

  angular
    .module('odRecords')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');


    
  }

})();

(function() {
  'use strict';

  angular
    .module('odRecords')
    .config(routeConfig);

  function routeConfig($routeProvider) {
    $routeProvider
      .when('/', {
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'vm'
      })
      .otherwise({
        redirectTo: '/'
      });
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('odRecords')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('odRecords')
    .config(config);

  /** @ngInject */
  function config($mdThemingProvider,$logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    var customPrimary = {
      '50': '#ff00bf',
      '100': '#e600ac',
      '200': '#cc0099',
      '300': '#b30086',
      '400': '#990073',
      '500': '#800060',
      '600': '#66004d',
      '700': '#4d003a',
      '800': '#330027',
      '900': '#1a0013',
      'A100': '#ff1ac6',
      'A200': '#ff33cc',
      'A400': '#ff4dd2',
      'A700': '#000000'
    };
    $mdThemingProvider
      .definePalette('customPrimary',
        customPrimary);

    var customAccent = {
      '50': '#060101',
      '100': '#1a0606',
      '200': '#2e0c0c',
      '300': '#431111',
      '400': '#571616',
      '500': '#6c1b1b',
      '600': '#942525',
      '700': '#a92a2a',
      '800': '#bd2f2f',
      '900': '#cd3939',
      'A100': '#942525',
      'A200': '#802020',
      'A400': '#6c1b1b',
      'A700': '#d24d4d'
    };
    $mdThemingProvider
      .definePalette('customAccent',
        customAccent);

    var customWarn = {
      '50': '#ffb280',
      '100': '#ffa266',
      '200': '#ff934d',
      '300': '#ff8333',
      '400': '#ff741a',
      '500': '#ff6400',
      '600': '#e65a00',
      '700': '#cc5000',
      '800': '#b34600',
      '900': '#993c00',
      'A100': '#ffc199',
      'A200': '#ffd1b3',
      'A400': '#ffe0cc',
      'A700': '#803200'
    };
    $mdThemingProvider
      .definePalette('customWarn',
        customWarn);

    var customBackground = {
      '50': '#626262',
      '100': '#555555',
      '200': '#484848',
      '300': '#3b3b3b',
      '400': '#2f2f2f',
      '500': '#222',
      '600': '#151515',
      '700': '#080808',
      '800': '#000000',
      '900': '#000000',
      'A100': '#6e6e6e',
      'A200': '#7b7b7b',
      'A400': '#888888',
      'A700': '#000000'
    };
    $mdThemingProvider
      .definePalette('customBackground',
        customBackground);

    $mdThemingProvider.theme('default')
      .primaryPalette('customPrimary')
      .accentPalette('customAccent')
      .warnPalette('customWarn')
      .backgroundPalette('customBackground')

  }

})();


angular.module("odRecords").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<link href=\"https://fonts.googleapis.com/css?family=Merriweather\" rel=stylesheet><md-content ui-view layout=column id=odPage style=\"background-color: black\"><!--<div ng-include=\"\'app/components/header/odHeader.html\'\"> </div>--><md-tabs md-dynamic-height md-border-bottom md-center-tabs=always md-stretch-tabs=always><md-tab label=\"Overdope Records\"><div flex ng-include=\"\'app/components/bands/overdopeRecords-include.html\'\"></div></md-tab><md-tab label=\"Rescue Team\"><div flex ng-include=\"\'app/components/bands/rescueTeam-include.html\'\"></div></md-tab><md-tab label=\"Sovnd Ordnance\"><div flex ng-include=\"\'app/components/bands/soundOrdnance-include.html\'\"></div></md-tab></md-tabs></md-content>");
$templateCache.put("app/components/bands/overdopeRecords-include.html","<div layout=row layout-fill><div flex></div><div layout=column style=\"background-color: #000000;width:900px;color:lightgray\" layout-align=\"center center\"><div layout=column layout-align=\"center center\"><div layout=row style=\"width: 900px\"><div flex></div><md-button class=md-icon-button aria-label=Email ng-click=vm.emailClick($event)><i class=\"zmdi zmdi-hc-2x zmdi-email overDopeWhite\"></i></md-button></div><img src=assets\\images\\OverdopeRecording-Logo.png><!--\n      <div>\n\n        <md-button hide-xs class=\"md-icon-button\" aria-label=\"Facebook\" ng-click=\"vm.testClick()\">\n          <i class=\"zmdi zmdi-hc-2x zmdi-facebook overDopeWhite\"></i>\n        </md-button>\n        <md-button hide-xs class=\"md-icon-button\" aria-label=\"iTunes\">\n          <i class=\"zmdi zmdi-hc-2x zmdi-apple overDopeWhite\"></i>\n        </md-button>\n        <md-button hide-xs class=\"md-icon-button\" aria-label=\"YouTube\">\n          <i class=\"zmdi zmdi-hc-2x zmdi-youtube overDopeWhite\"></i>\n        </md-button>\n        <md-button hide-xs class=\"md-icon-button\" aria-label=\"Soundcloud\">\n          <i class=\"zmdi zmdi-hc-2x zmdi-soundcloud overDopeWhite\"></i>\n        </md-button>\n      </div>\n      --></div><br><br></div><div flex></div></div>");
$templateCache.put("app/components/bands/rescueTeam-include.html","<div layout=row layout-fill><div flex></div><div layout=column style=\"background-color: #000000;width:900px;color:lightgray\" layout-align=\"center center\"><br><br><div layout=column layout-align=\"center center\"><div>Resuce Team is an electro pop band based in the San Francisco Bay area.</div><br><div>Resuce Team weaves electronic instruments with live vocals,</div><div>creating music that is both fun and introspective.</div><br><div>Rescue team is available for performances in the bay area.</div><br><div>\"You\'re definitely going to want to wear headphones for this album!\"</div><br></div><br><br><iframe style=\"border: 0; width: 560px; height: 315px\" src=\"https://bandcamp.com/EmbeddedPlayer/album=3933291210/size=large/bgcol=333333/linkcol=0f91ff/artwork=small/transparent=true/\" seamless><a href=http://rescueteam.bandcamp.com/album/rescue-team>Rescue Team by Rescue Team</a></iframe><br><div layout=row layout-align=center class=md-title style=\"border-top: 1px solid lightgray; border-bottom: 1px solid lightgray;padding:5px\">Video</div><div layout-padding><iframe width=560 height=315 src=https://www.youtube.com/embed/VxhWeFuFUX4 frameborder=0 allowfullscreen></iframe></div><div layout-padding><iframe width=560 height=315 src=https://www.youtube.com/embed/hjboDDZEac4 frameborder=0 allowfullscreen></iframe></div><div layout-padding><iframe width=560 height=315 src=https://www.youtube.com/embed/4fGpxYacKzU frameborder=0 allowfullscreen></iframe></div></div><div flex></div></div>");
$templateCache.put("app/components/bands/soundOrdnance-include.html","<div layout=row layout-fill><div flex></div><div layout=column style=\"background-color: #000000;width:900px;color:lightgray\" layout-align=\"center center\"><br><div layout=row layout-padding layout-align=\"center center\">Sovnd Ordnance is an experimental abstract witch hop electronic group refining what genre means.</div><br><div layout=row class=md-title style=\"border-top: 1px solid lightgray; border-bottom: 1px solid lightgray;padding:5px\">Albums</div><div layout=row layout-padding><iframe style=\"border: 0; width: 200px; height: 524px\" src=\"https://bandcamp.com/EmbeddedPlayer/album=2121418677/size=large/bgcol=333333/linkcol=ffffff/transparent=true/\" seamless><a href=http://sound-ordnance.bandcamp.com/album/silence-is-a-weapon>SILENCE IS A WEAPON by SOVND ORDNANCE</a></iframe><iframe style=\"border: 0; width: 200px; height: 524px\" src=\"https://bandcamp.com/EmbeddedPlayer/album=3612528250/size=large/bgcol=333333/linkcol=e99708/transparent=true/\" seamless><a href=http://sound-ordnance.bandcamp.com/album/rude-simulation>RUDE SIMULATION by SOVND ORDNANCE</a></iframe><iframe style=\"border: 0; width: 200px; height: 524px\" src=\"https://bandcamp.com/EmbeddedPlayer/album=173736453/size=large/bgcol=333333/linkcol=ffffff/transparent=true/\" seamless><a href=http://sound-ordnance.bandcamp.com/album/crying-diamonds>crying diamonds by SOVND ORDNANCE</a></iframe></div><div layout=row layout-padding><iframe style=\"border: 0; width: 200px; height: 524px\" src=\"https://bandcamp.com/EmbeddedPlayer/album=2440315173/size=large/bgcol=333333/linkcol=0f91ff/transparent=true/\" seamless><a href=http://sound-ordnance.bandcamp.com/album/return>RETURN by SOVND ORDNANCE</a></iframe><iframe style=\"border: 0; width: 200px; height: 524px\" src=\"https://bandcamp.com/EmbeddedPlayer/album=823804469/size=large/bgcol=333333/linkcol=8f61ff/transparent=true/\" seamless><a href=http://sound-ordnance.bandcamp.com/album/overcover>OVERCOVER by SOVND ORDNANCE</a></iframe><iframe style=\"border: 0; width: 200px; height: 524px\" src=\"https://bandcamp.com/EmbeddedPlayer/album=3133673341/size=large/bgcol=333333/linkcol=e32c14/transparent=true/\" seamless><a href=http://sound-ordnance.bandcamp.com/album/overdope>OVERDOPE by SOVND ORDNANCE</a></iframe></div><div layout=column style=\"background-color: #000000; color: lightgray\" layout-align=\"center center\"><br><div layout=row class=md-title style=\"border-top: 1px solid lightgray; border-bottom: 1px solid lightgray;padding:5px\">Video</div><br><iframe width=560 height=315 src=https://www.youtube.com/embed/LFSA15TdlOw frameborder=0 allowfullscreen></iframe></div><br></div><div flex></div></div>");
$templateCache.put("app/components/header/odHeader.html","<md-toolbar><div class=\"md-toolbar-tools overDopeWhite\" layout=row><div hide-xs class=md-headline layout-padding>Overdope Records</div><div hide-gt-xs class=md-headline layout-padding>ODR</div><div flex></div><div><md-button class=md-icon-button aria-label=Email ng-click=vm.testClick()><i class=\"zmdi zmdi-hc-2x zmdi-email overDopeWhite\"></i></md-button><md-button hide-xs class=md-icon-button aria-label=Facebook ng-click=vm.testClick()><i class=\"zmdi zmdi-hc-2x zmdi-facebook overDopeWhite\"></i></md-button><md-button hide-xs class=md-icon-button aria-label=iTunes><i class=\"zmdi zmdi-hc-2x zmdi-apple overDopeWhite\"></i></md-button><md-button hide-xs class=md-icon-button aria-label=YouTube><i class=\"zmdi zmdi-hc-2x zmdi-youtube overDopeWhite\"></i></md-button><md-button hide-xs class=md-icon-button aria-label=Soundcloud><i class=\"zmdi zmdi-hc-2x zmdi-soundcloud overDopeWhite\"></i></md-button><md-menu md-position-mode=\"target-right target\" hide-gt-xs><md-button aria-label=\"Open demo menu\" class=md-icon-button ng-click=$mdOpenMenu($event)><i class=\"zmdi zmdi-share overDopeWhite\"></i></md-button><md-menu-content width=4><md-menu-item ng-repeat=\"item in vm.shareMenuItems\"><md-button ng-click=ctrl.announceClick($index)><div layout=row layout-align=\"start center\" flex><i class=\"zmdi {{item.icon}}\" style=padding-right:1em></i><p flex>{{item.name}}</p></div></md-button></md-menu-item></md-menu-content></md-menu></div></div></md-toolbar>");
$templateCache.put("app/components/navbar/navbar.html","<md-toolbar layout=row layout-align=\"center center\"><md-button href=https://github.com/Swiip/generator-gulp-angular>Gulp Angular</md-button><section flex layout=row layout-align=\"left center\"><md-button href=# class=md-raised>Home</md-button><md-button href=# class=md-raised>About</md-button><md-button href=# class=md-raised>Contact</md-button></section><md-button class=acme-navbar-text>Application was created {{ vm.relativeDate }}.</md-button></md-toolbar>");
$templateCache.put("app/components/odPlayer/odPlayer.html","<div><!--\n  <iframe style=\"border: 0; width: 400px; height: 120px;\" src=\"https://bandcamp.com/EmbeddedPlayer/album=3933291210/size=large/bgcol=ffffff/linkcol=f171a2/tracklist=false/artwork=small/transparent=true/\" seamless><a href=\"http://rescueteam.bandcamp.com/album/rescue-team\">Rescue Team by Rescue Team</a></iframe>\n--><div class=\"md-headline layout-padding\">{{vm.currentBand.name}}</div><iframe style=\"border: 0; width: 350px; height: 786px\" src=\"https://bandcamp.com/EmbeddedPlayer/album=3933291210/size=large/bgcol=ffffff/linkcol=f171a2/transparent=true/\" seamless><a href=http://rescueteam.bandcamp.com/album/rescue-team>Rescue Team by Rescue Team</a></iframe></div>");}]);